import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    flexWrap: 'wrap',

    minHeight: '2.5rem',

    marginBottom: '0.5rem',

    min768: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
});

export const filtersContainer: TRuleWithTheme = () => ({
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    flexWrap: 'wrap',
});

export const selectButton: TRuleWithTheme = ({ theme }) => ({
    '&.ant-select': {
        border: '1px solid',
        borderColor: theme.colors.foregroundsTertiary,
        borderRadius: '1rem',
        padding: '0.5rem 0.75rem',
        height: '2rem',
        minHeight: 'unset',
        width: 'unset',
        minWidth: '6rem',
        boxShadow: 'none',

        transition: 'all 0.2s ease-in-out',

        '& .ant-select-content': {
            fontSize: '0.875rem',
            letterSpacing: '0.0125rem;',
        },

        '&.ant-select-show-search.ant-select-open': {
            minWidth: '12rem',
        },

        '& .ant-select-suffix > svg': {
            width: '1rem',
            height: '1rem',
        },
    },
});

export const searchInput: TRuleWithTheme = () => ({
    width: '100%',

    '&.ant-input-affix-wrapper': {
        height: '2.25rem',
    },

    min768: {
        maxWidth: '15.625rem',
    },
});

export const batchActionsContainer: TRuleWithTheme = () => ({
    display: 'flex',
    columnGap: '1rem',
    alignItems: 'center',
    flexWrap: 'wrap',
});
